import {EnvManager} from "./helpers/envirements";

export const USER_AUTHENTICATION_ADDRESS = "/mobile/api/children/auth/token";
export const EQUEUES_LIST_ADDRESS =
  `/health/v2/doctor-records/MP_HEALTH`;
export const SELECT_EQUEUE_ADDRESS = `/health/v1/api/lk/v1/feeds/`;
export const USER_INFO_ADDRESS = `/health/v1/api/lk/v1/users/data?_=`;
export const R_N_M_FIRST_STEP_ADDRESS = `/health/v2/create-statement`;


export const R_N_M_SECOND_STEP_ADDRESS = `/health/v1/api/nsi/v1/dictionary/mzrf_equeue_regions`;
export const R_N_M_SIX_STEP_ADDRESS = `/health/v2/lpu`;


export const R_N_M_FOURTH_STEP_ADDRESS = `/health/v2/check-region-availability/`;
export const R_N_M_FIFTH_STEP_ADDRESS = `/health/v2/patient-validation`;
export const DOCTORS_SPECIALITIES_LOADING_ADDRESS = `/health/v2/specialities`;
export const DOCTORS_NAMES_LOADING_ADDRESS = `/health/v2/doctors`;
export const DATES_LOADING_ADDRESS = `/health/v2/slots`;

export const panels = {
  login: "login",
  equeues: "equeues",
  selectedEqueue: "selected-equeue",
  error: "error",
  customError: "customError",
  removeOldRecordError: "removeOldRecordError",
  userInfo: "user-info",
  regionAndMedicalOrganisation: "region-and-medical-organisation",
  regions: "regions",
  regionSearchPanel: "region-search-panel",
  medicalOrganisationSelector: "medical-organisation-selector",
  doctor: "doctor",
  doctorSpecialitySelector: "doctor-speciality-selector",
  doctorNameSelector: "doctor-name-selector",
  choseDate: "chose-date",
  chooseTime: "choose-time",
  confirmPanel: "confirm-panel",
  oms: "oms-panel",
  moscowRegionDoctorPanel: "moscow-region-doctor-panel",
};
export const alerts = {
  confirmCancelEqueue: "confirm-cancel-equeue",
};
export const months = [
  "января",
  "февраля",
  "марта",
  "апреля",
  "мая",
  "июня",
  "июля",
  "августа",
  "сентября",
  "октября",
  "ноября",
  "декабря",
];

export const months_u = [
  "Январь",
  "Февраль",
  "Март",
  "Апрель",
  "Май",
  "Июнь",
  "Июль",
  "Август",
  "Сентябрь",
  "Октябрь",
  "Ноябрь",
  "Декабрь",
];

export const weekDays = [
  "понедельник",
  "вторник",
  "среда",
  "четверг",
  "пятница",
  "суббота",
  "воскресенье",
];

export const weekDays_short = [
  "ВС",
  "ПН",
  "ВТ",
  "СР",
  "ЧТ",
  "ПТ",
  "СБ",
  "ВС",
  "ПН",
  "ВТ",
  "СР",
  "ЧТ",
  "ПТ",
  "СБ",
];
